/** Fine engraved surfaces for the campaign atlas, shared across the entire chart. */
function etching(): string {
  const paths: string[] = [];
  for (let row = 0; row < 24; row++) {
    const y = row * 1.75 + 0.3;
    const bend = Math.sin(row * 1.7) * 0.7;
    const x = (row * 13) % 19 - 8;
    paths.push(`M${x} ${y.toFixed(2)}c6 ${bend.toFixed(2)} 10 ${(-bend).toFixed(2)} 17 0` +
      `m2.1 .2c9 ${(-bend).toFixed(2)} 14 ${bend.toFixed(2)} 21 -.1m3 0q8 ${bend.toFixed(2)} 17 0`);
  }
  return paths.join('');
}

function grain(): string {
  return Array.from({ length: 58 }, (_, i) => {
    const x = ((i * 7.137) % 12).toFixed(2), y = ((i * 3.371) % 10).toFixed(2);
    return `M${x} ${y}l${(0.06 + (i % 4) * 0.08).toFixed(2)} ${i % 2 ? '.07' : '-.05'}`;
  }).join('');
}

const DEFS = `<pattern id="wm-atlas-water" patternUnits="userSpaceOnUse" width="64" height="42">
  <path d="${etching()}" fill="none" stroke="#080f12" stroke-width=".085" opacity=".53"/>
  <path d="M34 18c-10-8-18-4-15 .2s16 3 15-.2c-1-3-13-4-12-.2s8 2 8 .2
    M14 18c-4 5 18 10 24 4s-13-12-23-7M10 26c13 8 24 3 29 1s10-4 19-1
    M6 27c8 5 18 7 29 4s19-5 28-2M39 9c4-5 15-4 14 0s-8 3-8 .3s5-1.8 5-.3"
    fill="none" stroke="#0b1518" stroke-width=".11" opacity=".55"/>
  <path d="M2 8q7-1 14 .2M38 35q9-1.5 21 0M2 39q8-1 12 0"
    fill="none" stroke="#8b9581" stroke-width=".055" opacity=".13"/>
</pattern>
<pattern id="wm-atlas-grain" patternUnits="userSpaceOnUse" width="12" height="10">
  <path d="${grain()}" fill="none" stroke="#242c20" stroke-width=".06" opacity=".33"/>
  <path d="M1.4 2.5l.16-.08M6.4 8l.22 .06M10.2 5l.1-.1M4 4l.2 .08"
    fill="none" stroke="#d1c99d" stroke-width=".065" opacity=".3"/>
</pattern>
<g id="wm-atlas-ruins" stroke="none">
  <path d="M-2.5.5L-1.1-.5L1.9-.2L3 1L.7 1.6L-1.8 1.3Z" fill="#263328" opacity=".42"/>
  <path d="M-1.8.8V-1.2L-1.3-1.6L-.9-1.5V-.7L-.3-.9V.7Z" fill="#8a8770"/>
  <path d="M-.3-.9L.1-.6V1L-.3.7Z" fill="#454f41"/>
  <path d="M-.7.1L.9-.2V-1.9L1.3-2.1L1.9-1.5V.7L-.7 1.1Z" fill="#72765e"/>
  <path d="M1.3-2.1L1.9-1.5V.7L1.4 1V-1.4Z" fill="#46513f"/>
  <path d="M-1.8-1.2L-1.3-1.6L-.9-1.5L-1.3-1.2ZM.9-1.9L1.3-2.1L1.9-1.5L1.4-1.7Z" fill="#b5ac89"/>
  <path d="M-.5.9L.1.4L.7.7L.4 1.1ZM-2.5 1L-2.1.65L-1.7 1L-2 1.2ZM1.7 1.1L2.3.5L2.6 1L2.2 1.4Z" fill="#a49d7f"/>
</g>`;

export function atlasTextureDefs(): string { return DEFS; }
